// Tiện ích môi trường dùng chung cho mọi component.
// Breakpoint PHẢI khớp libraryMainsite 1.3.0 (mobile = rộng ≤ 768 và đang dọc) và mixin SCSS trong webpack.config.js.
export const MQ_MOBILE = '(max-width: 768px) and (orientation: portrait)';
export const mqMobile = window.matchMedia(MQ_MOBILE);
export const isMobile = () => mqMobile.matches;
export const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

export const $ = (sel, root = document) => root.querySelector(sel);
export const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

export function onReady(fn) {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
  else fn();
}

// localStorage có thể ném lỗi (Safari private, chặn cookie) → luôn bọc try/catch
export const store = {
  get(key, fallback = null) {
    try {
      const v = localStorage.getItem(key);
      return v === null ? fallback : v;
    } catch (e) {
      return fallback;
    }
  },
  set(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      /* bỏ qua: chỉ mất tính năng nhớ lựa chọn */
    }
  },
};

export function debounce(fn, ms) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), ms);
  };
}

export function emit(name, detail) {
  document.dispatchEvent(new CustomEvent(name, { detail }));
}

// Khi chạy tiến trình nền (autoplay, particle) phải tôn trọng tab ẩn để tiết kiệm pin/CPU
export const pageVisible = () => document.visibilityState === 'visible';
